export default __webpack_public_path__ + "static/media/915.11c075ad.gif";